import { types } from '../actions/FormActions';
import { types as sessionTypes } from '../actions/SessionActions';
import _ from 'lodash';

const INITIAL_STATE = {

    errors: {
        date: null,
        time: null,
        party: null,
        firstName: null,
        lastName: null,
        policyError:null,
        showPolicyError:false,
        email: null,
        phone: null,
        requests: null,
        customFields: null
    },
    reservation: {
        date: null,
        time: null,
        party: null,
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        requests: null,
        customFields: {},
        location: null,
    },
    options: {
        party: [],
        time: [],
        date: {}
    }
};

const HANDLERS = {
    [types.INIT_FORM]: (payload, state) => {
        const { reservation, errors, options } = payload;
        const newState = _.cloneDeep(state);
        let changed = false;

        newState.errors = errors;
        if (reservation && !_.isEqual(reservation, state.reservation)) {
            newState.reservation = reservation;
            changed = true;
        }
        if (options && !_.isEqual(options, state.options)) {
            newState.options = options;
            changed = true;
        }
        if(errors && errors.policyError!==state.errors.policyError)
        {
            newState.errors.policyError=errors.policyError
            changed=true
        }
        if(errors && errors.showPolicyError!==state.errors.showPolicyError)
        {
            newState.errors.showPolicyError=errors.showPolicyError
            changed=true
        }
        return changed ? newState : state;
    },

    [types.SET_FORM_OPTIONS]: (payload, state) => {
        const { partyOptions, excludeDates, timeOptions } = payload;
        let changed = false;
        let newState = _.cloneDeep(state);
        const currentExcludeDates = _.get(state, 'options.date.excludeDates', {})
        const excludeDateReset = !_.isUndefined(excludeDates) && !_.isEmpty(currentExcludeDates);
        if (partyOptions && !_.isEqual(state.options.party, partyOptions)) {
            newState.options.party = partyOptions;
            changed = true;
        }
        if ((!_.isEmpty(excludeDates) || excludeDateReset) && !_.isEqual(state.options.date, {excludeDates})) {
            newState.options.date = { excludeDates };
            changed = true;
        }
        if (timeOptions && !_.isEqual(state.options.time, timeOptions)) {
            newState.options.time = timeOptions;
            changed = true;
        }

        return changed ? newState : state;
    },

    [types.RESERVATION_VALIDATION_OK]: (payload, state) => {
        let newState = _.cloneDeep(state);
        newState.errors = {...state.errors};
        newState.errors.date = null;
        newState.errors.time = null;
        newState.errors.party = null;
        return newState;
    },

    [types.FULL_RESERVATION_VALIDATION_OK]: (payload, state) => {
        return {...state, ...{errors: INITIAL_STATE.errors}};
    },
    [types.SET_POLICY_ERROR]: (payload, state) => {
        return {...state, ...{errors:{...state.errors,policyError:payload.policyError}}};
    },
  [types.SET_SHOW_POLICY_ERROR]: (payload, state) => {
        return {...state, showPolicyError: payload.showPolicyError};
    },

    [types.FULL_RESERVATION_VALIDATION_ERROR]: (payload, state) => {
        const { errors } = payload;
        let newState = _.cloneDeep(state);
        newState.errors = Object.assign({}, INITIAL_STATE.errors);

        _.forEach(errors, error => {
            newState.errors[error.type] = error.error;
        });

        return newState;
    },

    [types.RESERVATION_VALIDATION_ERROR]: (payload, state) => {
        const { errors } = payload;
        let newState = _.cloneDeep(state);
        newState.errors = Object.assign({}, INITIAL_STATE.errors);

        _.forEach(errors, error => {
            newState.errors[error.type] = error.error;
        });

        return newState;
    },

    [types.UPDATE_RESERVATION_VALIDATION_ERROR]: (payload, state) => {
        const { errors } = payload;
        let newState = _.cloneDeep(state);

        _.forEach(errors, error => {
            newState.errors[error.type] = error.error;
        });

        return newState;
    },

    [types.UPDATE_FIELD]: (payload, state) => {
        const { value, type } = payload;
        let newState = _.cloneDeep(state);
        _.set(newState, `reservation.${type}`, value);
        return newState;
    },

    [types.SET_FIELDS]: (payload, state) => {
        let newState = _.cloneDeep(state);
        let shouldUpdate = false;

        _.forEach(payload, (value, key) => {
            if (!_.isEqual(value, _.get(newState, `reservation.${key}`))) {
                _.set(newState, `reservation.${key}`, value);
                shouldUpdate = true;
            }
        });

        return shouldUpdate ? newState : state;
    },

    [types.RESET_FORM]: (payload, state) => {
        const newState = _.cloneDeep(INITIAL_STATE);
        newState.options = _.cloneDeep(state.options);
        return newState;
    },

    [sessionTypes.FORM_END]: (payload, state) => {
        const newState = _.cloneDeep(state);
        newState.errors.firstName = '';
        newState.errors.lastName = '';
        newState.errors.phone = '';
        newState.errors.email = '';
        newState.errors.showPolicyError = false;
        newState.errors.policyError ='';
        newState.errors.requests = null;
        newState.errors.customFields = null;
        return newState;
    }
};

export default function(state = INITIAL_STATE, action = {}) {
    let handler = HANDLERS[action.type] || (() => state);
    return handler(action.payload, state);
}